export class WiredMessengerAccount {
  clientId;
  description;
  id;
  name;
  guid;
  constructor(obj?: WiredMessengerAccount) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/wired-messenger-accounts/wired-messenger-account.model.ts